import { createSelector, createSlice } from '@reduxjs/toolkit';
import { executeCallbackFunction } from '../../tools/callback.js';
import { redirect } from '../../helpers/redirection.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { saveCandidateJustLoggedInCookie } from '../../helpers/cookies.js';
import { twoStepLoginRegistrationSlice } from '../../forms/TwoStepLoginRegistration/twoStepLoginRegistrationSlice.js';
export const AUTH_SOURCES = {
    apple: 'apple',
    facebook: 'facebook',
    email: 'email',
};
export const initialAuthSuccessState = {
    source: null,
    code: null,
};
export const authSuccessSlice = createSlice({
    name: 'authSuccess',
    initialState: initialAuthSuccessState,
    reducers: {
        setAuthSuccess: (state, action) => {
            state.source = action.payload.source;
            state.code = action.payload.code;
        },
    },
});
const authSuccessState = (state) => state.core.authSuccess;
export const authSuccessSelector = createSelector(authSuccessState, ({ source, code }) => {
    return {
        ...(source && { source }),
        ...(code && { code }),
    };
});
const { setAuthSuccess } = authSuccessSlice.actions;
export const authSuccessThunk = (source, codeOrNull, additionalAuthData) => async (dispatch, getState) => {
    const state = getState();
    /* update status code only if it's passed in the thunk */
    const code = codeOrNull ?? state.core.authSuccess.code;
    dispatch(setAuthSuccess({ source, code }));
    const { redirectionUrl, callbackFunction } = state.core.sourceData;
    // comment out this code to disable the interstitial view for Apple login
    if (source === 'apple') {
        const { emailUpdateRequired, skipEmailUpdate } = additionalAuthData?.apple || {};
        if (emailUpdateRequired && !skipEmailUpdate) {
            const activeModalType = state.wrappers.modal.activeModalType;
            const isTwoStepModal = activeModalType === FORM_TYPES.FULLSCREEN_TWO_STEP ||
                activeModalType === FORM_TYPES.BASIC_TWO_STEP;
            if (isTwoStepModal) {
                console.log('Show interstitial view');
                dispatch(twoStepLoginRegistrationSlice.actions.updateTwoStepActiveState('appleUpdateEmail'));
                return;
            }
        }
    }
    console.log('state.core.authSuccess.code: ', state.core.authSuccess.code);
    if (callbackFunction) {
        executeCallbackFunction(callbackFunction);
    }
    saveCandidateJustLoggedInCookie();
    redirect(redirectionUrl);
};
export default authSuccessSlice.reducer;
//# sourceMappingURL=authSuccessSlice.js.map